import iconLink from "../../../../assets/icon_link.svg";
import useReactGASend from "../../../../hooks/useReactGASend";

const WebLinkButton = ({ label, href }) => {
  const { makeEventTrackFn } = useReactGASend();

  const handleClick = () => {
    makeEventTrackFn({
      category: "event",
      action: `${label}(FAQ)`,
      data_btn_nm: `${label}(FAQ)`,
      data_btn_url: href,
    });
  };

  return (
    <a
      href={href}
      target="_blank"
      className="flex items-center justify-center gap-6 p-2 font-medium leading-none border-[1px] min-h-12 w-64 text-brand-button-text-dialog border-brand-button-border-dialog rounded-2xl"
      onClick={handleClick}
    >
      <img src={iconLink} alt="" />
      {label}
    </a>
  );
};

export default WebLinkButton;
